import { cn } from 'common/utils';
import SuggestedCreatorsWidget from 'components/v2/organisms/suggested-creators-widget';
import TopicWidget from 'components/v2/organisms/topic-widget';
import { MinimizedUserInfoType } from 'service/timeline';
import { UserTopicTypeWithPostCount } from 'service/user';

const TopicRightSidebar = ({
  topics,
  contributors,
  isFetched,
}: {
  topics: UserTopicTypeWithPostCount[];
  contributors: MinimizedUserInfoType[];
  isFetched: boolean;
}) => {
  return (
    <aside
      className={cn(
        'scrollbar-hide sticky top-16 z-50 ml-auto hidden h-[calc(100vh-64px)] w-[260px] overflow-y-auto pb-3 pt-[15px] grid-in-rightSidebar xl:block',
      )}
    >
      <div className="space-y-8 px-5">
        {/* Related Topics Widget */}
        <TopicWidget
          topics={topics}
          isFetched={isFetched}
          title="関連トピック"
        />

        {/* Top Contributors Widget */}
        <SuggestedCreatorsWidget
          creators={contributors}
          title="トップコントリビューター"
        />
      </div>
    </aside>
  );
};

export default TopicRightSidebar;
